import { action, observable, makeObservable } from 'mobx';
import {
  contentLoaders,
  SuccessResponse,
  X9ContentType,
  X9ContentUpdateModel
} from '../../../../domain';
import {HttpPromiseState, SaveStateHolder} from '../../../../lib/helpers';
import {X7PushableBlockStore} from '../X7PushableBlockStore';

export class AddContentStore implements SaveStateHolder {
  @observable
  valid: boolean;

  @observable
  contents: string;

  @observable
  touched: boolean;

  @observable.ref
  save: HttpPromiseState<SuccessResponse> | null;

  constructor(private readonly parent: X7PushableBlockStore,
              readonly blockId: number,
              readonly contentType: X9ContentType) {
    makeObservable(this);
    this.valid = true;
    this.contents = '';
    this.touched = false;
    this.save = null;
  }

  @action
  setValid = (valid: boolean) => {
    this.valid = valid;
  };

  @action
  setContents = (value: string) => {
    this.contents = value;
  };

  @action
  markTouched = () => {
    this.touched = true;
  };

  @action
  complete = () => {
    if (this.save?.isPending === true)
      return;
    this.markTouched();
    if (!this.valid)
      return;
    let model: X9ContentUpdateModel = {
      BlockId: this.blockId,
      ContentType: this.contentType,
      Contents: this.contents
    };
    this.save = contentLoaders.x9content.insert(model);
  };

  @action
  cancel = () => {
    this.parent.cancel();
  }
}
